import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Subheader = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  padding: "15px 0",
});
